import { useState, useContext } from "react"
import { gql, useQuery } from "@apollo/client"

import { LoaderProgressBar } from "../../../components/Loaders"

import { InputSwitch } from "primereact/inputswitch"
import { useFormikContext } from "formik"

import { UserContext } from "../../../context/userContext"

// Styles
import styles from "../../../styles/Form.module.css"

export default function HandleKioskSwitch() {
  const [kioskEnabled, setKioskEnabled] = useState(false)
  const formik = useFormikContext()

  const userCtx = useContext(UserContext)

  const MICROSERVICES_BY_ENTERPRISE = gql`
    query GetMicroservices(
      $staff_id: ID!
      $staff_organization_id: ID!
      $enterprise_id: ID!
    ) {
      microservices: getMicroservicesByEnterprise(
        staff_id: $staff_id
        staff_organization_id: $staff_organization_id
        enterprise_id: $enterprise_id
      ) {
        microservices_id
        microservices_name
      }
    }
  `

  const { loading } = useQuery(MICROSERVICES_BY_ENTERPRISE, {
    fetchPolicy: "network-only",
    variables: {
      staff_id: userCtx.session.user.staff_id,
      staff_organization_id: userCtx.session.user.organization_id,
      enterprise_id: userCtx.session.user.enterprise_id,
    },
    skip: !userCtx,
    onCompleted: (data) => {
      const microserviesList = data.microservices || []

      if (microserviesList.length === 0) {
        return
      }

      const isKioskEnabled = microserviesList.some(
        (microservice) => microservice.microservices_id === "10"
      )

      isKioskEnabled && setKioskEnabled(true)
    },
    onError: (error) => {
      console.error(error)
    },
  })

  // Cannot fall back to 'null' because the value could be 0, which is also falsy.
  const currentvalue = formik.values?.kiosk

  if (loading) return <LoaderProgressBar />

  const hideToogle =
    currentvalue === -1 || currentvalue === null || !kioskEnabled

  if (hideToogle) return null

  return (
    <div className={styles.field}>
      <label className={styles.label}>Integrate with Kiosk</label>
      <div className={styles.description}>
        Enable this template for configuration with Kiosk forms.
      </div>
      <div>
        <InputSwitch
          checked={currentvalue === 1}
          onChange={(e) => formik.setFieldValue("kiosk", e.value ? 1 : 0)}
        />
      </div>
    </div>
  )
}
